export enum PhotoStatus {
  PROCESSING = 'PROCESSING',
  UNREVIEWED = 'UNREVIEWED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export function isPhotoPending(status: string | null | undefined): boolean {
  return status === PhotoStatus.PROCESSING || status === PhotoStatus.UNREVIEWED;
}

export function isPhotoApproved(status: string | null | undefined): boolean {
  return status === PhotoStatus.APPROVED;
}

export function isPhotoRejected(status: string | null | undefined): boolean {
  return status === PhotoStatus.REJECTED;
}

export function shouldDisplayOwnerPhoto(status: string | null | undefined, imageUrl: string | null | undefined): boolean {
  return Boolean(imageUrl);
}

/** Label shown over blurred owner photos that are not yet approved. */
export function photoStatusOverlayLabel(status: string | null | undefined): string | null {
  if (isPhotoPending(status)) {
    return 'PENDING';
  }
  if (isPhotoRejected(status)) {
    return 'NOT APPROVED';
  }
  return null;
}
